import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import "./styles.css";
import beicaGif from '../images/Beica.gif';

// Register the MotionPathPlugin
gsap.registerPlugin(MotionPathPlugin);

export default function Animation() {
  const pathRef = useRef(null); // Ref for the SVG path
  const gifRef = useRef(null); // Ref for the GIF

  useEffect(() => {
    const path = pathRef.current;
    const length = path.getTotalLength(); // Get the total length of the path

    // Animate the SVG path
    gsap.fromTo(
      path,
      { strokeDasharray: length, strokeDashoffset: length },
      { strokeDashoffset: 0, duration: 8, repeat: -1, ease: "power1.inOut" }
    );

    // Set the initial position of the GIF outside the left boundary and adjust its y position
    gsap.set(gifRef.current, { x: -200, y: -30, opacity: 1 }); // Adjust the y value to align with the path

    // Animate the GIF along the path with rotation
    gsap.to(gifRef.current, {
      duration:7,
      motionPath: {
        path: path,
        align: path,
        alignOrigin: [0.5, 0.5],
        autoRotate: true, // Automatically rotate to align with the path direction
      },
      repeat: -1,
      ease: "power1.inOut",
      onRepeat: () => {
        // Reset position to start after each cycle
        gsap.set(gifRef.current, { x: -200, y: -30, opacity: 1 }); // Adjust the y value here as well
      },
      transformOrigin: "center center", // Set the transform origin
    });
  }, []);

  return (
    <div className="container relative min-h-[150px] sm:min-h-[300px] min-w-[110%] ml-[-5%]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 100"
        className="svg-animation w-full max-h-[300px]"
      >
        <path
          ref={pathRef} // Attach the ref to the path
          d="M0 43.9999C106.667 43.9999 213.333 7.99994 320 7.99994C426.667 7.99994 533.333 43.9999 640 43.9999C746.667 43.9999 853.333 7.99994 960 7.99994C1066.67 7.99994 1173.33 43.9999 1280 43.9999C1386.67 43.9999 1440 19.0266 1440 9.01329"
          fill="transparent"
          strokeWidth="12"
          strokeLinecap="round"
        />
      </svg>

      <div
        ref={gifRef}
        className="box  sm:h-24 sm:w-[250px] w-[100px] h-12   "
        alt="Animated GIF"
      >    <img

          className=""
          loading="lazy"
          src={beicaGif}
          alt="Animated GIF"
        /></div>
    </div>
  );
}
